// variant radios - обернуто в перевірку на jQuery
if (typeof jQuery !== "undefined") {
  jQuery(document).ready(function ($) {
    $(".product-form__buttons>span").click(function () {
      $(".select-a-variant-js").show();
      $(".variant__radios").addClass("variant-radios-unchecked");

      const targetElement = $(".select-a-variant-js");

      function isElementInViewport(el) {
        const offset = el.offset();
        const top = offset.top;
        const left = offset.left;
        const windowHeight = $(window).height();
        const windowWidth = $(window).width();

        return (
          top >= $(window).scrollTop() &&
          left >= $(window).scrollLeft() &&
          top + el.height() <= windowHeight + $(window).scrollTop() &&
          left + el.width() <= windowWidth + $(window).scrollLeft()
        );
      }

      // Check if the element is in the viewport
      if (isElementInViewport(targetElement)) {
        console.log("Element is in the viewport");
      } else {
        $("html, body").animate(
          {
            scrollTop: $(".main-product").offset().top,
          },
          1000
        );
      }
    });

    $(".variant__radios").click(function () {
      $(".product-form__buttons>span,.select-a-variant-js").hide();
      $(".variant__radios").addClass("variant-radios-checked");
    });
  });
}

// Додатковий глобальний обробник для перехоплення submit форми
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (form && form.getAttribute("data-type") === "add-to-cart-form") {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Знайти product-form елемент
        const productForm = form.closest("product-form");
        if (productForm && productForm.onSubmitHandler) {
          productForm.onSubmitHandler(e);
        }
        return false;
      }
    },
    true
  ); // use capture phase
});

// Product drawer
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector("span");
          if (document.querySelector("cart-drawer")) {
            this.submitButton.setAttribute("aria-haspopup", "dialog");
          }
        }

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      get cart() {
        return (
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer")
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) {
          return;
        }

        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }

        this.handleErrorMessage();

        const variantIdInput = this.variantIdInput;
        const variantId = variantIdInput?.value;
        console.log("[ProductForm] Submitting form, variant ID:", variantId);
        console.log("[ProductForm] Form ID:", this.form?.id);
        console.log("[ProductForm] Form element:", this.form);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const loadingSpinner = this.querySelector(".loading__spinner");
        if (loadingSpinner) {
          loadingSpinner.classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        console.log("[ProductForm] FormData variant ID:", formData.get("id"));

        const cartEl =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");
        if (cartEl) {
          formData.append(
            "sections",
            cartEl.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cartEl.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              if (this.submitButtonText) {
                this.submitButtonText.classList.add("hidden");
              }
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            // Пропускаємо publish якщо він викликає помилки
            if (!this.error) {
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker(
                    "add:wait-for-subscribers",
                    startMarker
                  );
                });
              } catch (e) {
                console.warn("Publish failed:", e);
              }
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            const drawer = document.querySelector("cart-drawer");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        if (drawer) {
                          drawer.renderContents(response);
                          drawer.open();
                        }
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              try {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  if (drawer) {
                    drawer.renderContents(response);
                    drawer.open();
                  }
                });
              } catch (e) {
                // На випадок помилки все одно пробуємо відкрити drawer
                if (drawer) {
                  try {
                    drawer.open();
                  } catch (e2) {
                    // Silent fail
                  }
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            const loadingSpinner = this.querySelector(".loading__spinner");
            if (loadingSpinner) {
              loadingSpinner.classList.add("hidden");
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute("disabled");
          if (this.submitButtonText && window.variantStrings) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
